import { createStorefrontApiClient } from "@shopify/storefront-api-client";
const requireEnv = (value, name) => {
    if (!value) {
        throw new Error(`Missing environment variable: ${name}`);
    }
    return value;
};
const shopify = createStorefrontApiClient({
    storeDomain: requireEnv(process.env.storeDomain, "SHOPIFY_STORE_URL"),
    apiVersion: requireEnv(process.env.apiVersion, "API_VER"),
    publicAccessToken: requireEnv(process.env.publicAccessToken, "SHOPIFY_STOREFRONT_TOKEN"),
});
export default shopify;
